<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-card", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-start align-items-center mb-1" },
      [
        _c(
          "h3",
          { staticClass: "mb-0 back_button" },
          [
            _c("BackButton"),
            _c("span", [_vm._v(_vm._s(_vm.$t("wallet.Deposit")))]),
          ],
          1
        ),
      ]
    ),
    _c("div", [
      _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "pl-0 pr-0", attrs: { md: "12" } },
                    [
                      _c("div", { staticClass: "text-lable mb-1" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("wallet.Select-Coin")) + " "
                        ),
                        _c("span", { staticClass: "red-star" }, [_vm._v("*")]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-20-p" },
                        [
                          _c("CurrencySelectObject", {
                            staticClass: "min-drop mb-1",
                            attrs: {
                              name: _vm.$t("wallet.Select-Coin"),
                              autocomplete: "off",
                              clearable: false,
                              options: _vm.coins,
                            },
                            model: {
                              value: _vm.coin,
                              callback: function ($$v) {
                                _vm.coin = $$v
                              },
                              expression: "coin",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "b-col",
                    { staticClass: "pl-0 pr-0", attrs: { md: "12" } },
                    [
                      _c("div", { staticClass: "text-lable mb-1 mt-1" }, [
                        _vm._v(" " + _vm._s(_vm.$t("wallet.Network")) + " "),
                        _c("span", { staticClass: "red-star" }, [_vm._v("*")]),
                      ]),
                      _c(
                        "div",
                        [
                          _c("b-form-input", {
                            attrs: {
                              disabled: "",
                              placeholder: _vm.$t("wallet.Network"),
                            },
                            model: {
                              value: _vm.network,
                              callback: function ($$v) {
                                _vm.network = $$v
                              },
                              expression: "network",
                            },
                          }),
                          _vm.coin &&
                          _vm.coin.contractAddress &&
                          _vm.coin.contractAddress.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "placeholder-below-text d-flex justify-content-end",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("wallet.ContractAddress")
                                        ) +
                                        " "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        "***" +
                                          _vm._s(
                                            _vm.coin.contractAddress.slice(-4)
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.coin
                    ? _c(
                        "b-col",
                        { staticClass: "pl-0 pr-0", attrs: { md: "12" } },
                        [
                          _c(
                            "div",
                            { staticClass: "mt-2 mb-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "text-lable mb-1 mt-1" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("wallet.Deposit-Address")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "b-row",
                                { staticClass: "ml-0 mr-0" },
                                [
                                  !_vm.address
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "pl-0 pr-0 mb-1 border rounded d-flex justify-content-between text-bold",
                                          attrs: { lg: "12" },
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { lg: "12" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-modal mb-1",
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "wallet.Address"
                                                          )
                                                        )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-baseline",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-modal mr-1 w-rt",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "wallet.Address-thr",
                                                              {
                                                                coin: _vm.coin
                                                                  .id,
                                                              }
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "mt-1",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "sm",
                                                  },
                                                  on: {
                                                    click: _vm.createAddress,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "align-middle",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "wallet.GetAddress"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "b-col",
                                        {
                                          staticClass: "pl-0 pr-0",
                                          attrs: { lg: "12" },
                                        },
                                        [
                                          _c(
                                            "b-alert",
                                            {
                                              staticClass: "d-flex",
                                              attrs: {
                                                variant: "primary",
                                                show: "",
                                              },
                                            },
                                            [
                                              _vm.coin &&
                                              _vm.coin.contractAddress &&
                                              _vm.coin.contractAddress.length
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "info-card-r",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Dispute-Status-pop.data-5",
                                                              {
                                                                coin: _vm.coin
                                                                  .id,
                                                              }
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "info-card-r",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Dispute-Status-pop.warningContractAddressNull",
                                                              {
                                                                coin: _vm.coin
                                                                  .coinName,
                                                                network:
                                                                  _vm.coin
                                                                    .network,
                                                              }
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "border rounded d-flex justify-content-between qr-code-block",
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "w-75 mobile-100",
                                                  attrs: { lg: "8" },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-modal mb-1",
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "wallet.Address"
                                                              )
                                                            )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-baseline add-h",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-modal w-rt",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.address
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("copy", {
                                                            staticClass:
                                                              "pointer",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.copy(
                                                                  _vm.address
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm.QRcodeImage
                                                ? _c(
                                                    "b-col",
                                                    {
                                                      staticClass:
                                                        "pr-0 d-flex justify-content-end align-items-center mobile-100 code-img",
                                                      attrs: { lg: "4" },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mr-1 orcode",
                                                        },
                                                        [
                                                          _c(
                                                            "VueQRCodeComponent",
                                                            {
                                                              staticClass:
                                                                "mb-0 orimg",
                                                              attrs: {
                                                                text: _vm.address,
                                                                size: 100,
                                                                "error-level":
                                                                  "L",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "minimum-withdrawal-text",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("wallet.Minimum-Deposit")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "minimum-deposit-amount",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                (_vm.coin && _vm.coin.minDeposit != null
                                                  ? _vm.coin.minDeposit
                                                  : _vm.getCoinMinDeposit(_vm.coin ? _vm.coin.id : "")) +
                                                  " " +
                                                  (_vm.coin ? _vm.coin.id : "")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "minimum-withdrawal-text",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("wallet.ExpectedArrival")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "minimum-deposit-amount",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                (_vm.coin && _vm.coin.minConfirmation != null
                                                  ? _vm.coin.minConfirmation
                                                  : _vm.getCoinMinConfirmation(_vm.coin ? _vm.coin.id : "")) +
                                                  " " +
                                                  _vm.$t("wallet.confirmations")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      [
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-start align-items-center mb-1 mt-3",
          },
          [
            _c("div", { staticClass: "d-flex justify-content-between w-100" }, [
              _c("div", [
                _c("h3", [_vm._v(_vm._s(_vm.$t("wallet.RecentDeposits")))]),
              ]),
              _c(
                "div",
                { staticClass: "refresh-button" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-icon",
                      attrs: { variant: "flat-primary" },
                      on: { click: _vm.getAllTransactionHistory },
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "RotateCwIcon" } }),
                      _c("span", { staticClass: "align-middle ml-1" }, [
                        _vm._v(_vm._s(_vm.$t("wallet.Refresh"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _c("b-table", {
          attrs: {
            items: _vm.items,
            fields: _vm.fields,
            "show-empty": "",
            responsive: "",
          },
          scopedSlots: _vm._u([
            {
              key: "cell(toAddress)",
              fn: function (data) {
                return [
                  _c(
                    "b-link",
                    { staticClass: "no-wrap" },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.v-primary",
                              modifiers: { hover: true, "v-primary": true },
                            },
                          ],
                          staticClass: "mr-1",
                          attrs: { title: data.value },
                        },
                        [_vm._v(_vm._s(data.item.toAddressStr))]
                      ),
                      _c("copy", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.v-primary",
                            modifiers: { hover: true, "v-primary": true },
                          },
                        ],
                        attrs: { title: _vm.$t("wallet.Copy") },
                        on: {
                          click: function ($event) {
                            return _vm.copy(data.value)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "cell(txId)",
              fn: function (data) {
                return [
                  data.value
                    ? _c(
                        "b-link",
                        { staticClass: "no-wrap" },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.v-primary",
                                  modifiers: { hover: true, "v-primary": true },
                                },
                              ],
                              staticClass: "mr-1",
                              attrs: { title: data.value },
                            },
                            [_vm._v(_vm._s(data.item.txIdStr))]
                          ),
                          _c("copy", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.v-primary",
                                modifiers: { hover: true, "v-primary": true },
                              },
                            ],
                            attrs: { title: _vm.$t("wallet.Copy") },
                            on: {
                              click: function ($event) {
                                return _vm.copy(data.value)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
          ]),
        }),
        _c(
          "b-row",
          [
            _c(
              "b-col",
              {
                staticClass:
                  "d-flex align-items-center justify-content-center justify-content-sm-end",
                attrs: { cols: "12", sm: "12" },
              },
              [
                _vm.items.length
                  ? _c(
                      "b-link",
                      {
                        staticClass: "textDecoration",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              path: "transactionHistory",
                              params: { lang: _vm.lang || undefined },
                            })
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("wallet.ViewMore>>")) + " ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/wallet/Deposit.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import assets_rashi_coin_ORcode_jpg from '@/assets/rashi-coin/ORcode.jpg';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import * as vuex from 'vuex';
import layouts_components_CurrencySelectObject_vue from '@/layouts/components/CurrencySelectObject.vue';
import layouts_components_DatePicker_vue from '@/layouts/components/DatePicker.vue';
import utils_clipboard from '@/utils/clipboard';
import utils_constants from '@/utils/constants';
import vue_qrcode_component from 'vue-qrcode-component';
import layouts_components_BackButton_vue from '@/layouts/components/BackButton.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BAlert: bootstrapvue["BAlert"],
    BRow: bootstrapvue["BRow"],
    QRcode: assets_rashi_coin_ORcode_jpg,
    BCol: bootstrapvue["BCol"],
    BImg: bootstrapvue["BImg"],
    BContainer: bootstrapvue["BContainer"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BAvatar: bootstrapvue["BAvatar"],
    BBadge: bootstrapvue["BBadge"],
    vSelect: vue_select,
    BFormInput: bootstrapvue["BFormInput"],
    BDropdown: bootstrapvue["BDropdown"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BInputGroupText: bootstrapvue["BInputGroupText"],
    BDropdownItem: bootstrapvue["BDropdownItem"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BFormDatepicker: bootstrapvue["BFormDatepicker"],
    copy: assets_rashi_coin_copy_svg,
    VueQRCodeComponent: vue_qrcode_component,
    CurrencySelectObject: layouts_components_CurrencySelectObject_vue,
    DatePicker: layouts_components_DatePicker_vue,
    BackButton: layouts_components_BackButton_vue
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  data() {
    return {
      fields: [{
        key: "createdTime",
        label: this.$t("Order.CreateTime"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "txType",
        label: this.$t("transactionHistory.Type")
      }, {
        key: "coin",
        label: this.$t("transactionHistory.Coin")
      }, {
        key: "totalAmount",
        label: this.$t("transactionHistory.Amount")
      }, {
        key: "toAddress",
        label: this.$t("transactionHistory.Destination")
      }, {
        key: "txId",
        label: this.$t("transactionHistory.TxId")
      }, {
        key: "txStatus",
        label: this.$t("transactionHistory.Status")
      }],
      items: [],
      page: 1,
      size: 10,
      lang: this.$route.params.lang,
      isPaginationVisible: false,
      totalRows: 0,
      address: "",
      network: "",
      coin: null,
      QRcodeImage: "sf"
    };
  },
  computed: {
    ...vuex.mapState("user", ["refData", "user", "coins"])
  },
  mounted() {
    const queryCoin = (this.$route && this.$route.query && this.$route.query.coin) || "USDT_TRX";
    const queryNetwork = (this.$route && this.$route.query && this.$route.query.network) || "TRX";
    const matchedCoin = this.coins && this.coins.find(c => c.id === queryCoin || c.coin === queryCoin);
    this.coin = {
      id: queryCoin,
      coin: queryCoin,
      network: queryNetwork || (matchedCoin ? matchedCoin.network : "TRX"),
      minDeposit: matchedCoin && matchedCoin.minDeposit != null ? matchedCoin.minDeposit : this.getCoinMinDeposit(queryCoin),
      minConfirmation: matchedCoin && matchedCoin.minConfirmation != null ? matchedCoin.minConfirmation : this.getCoinMinConfirmation(queryCoin),
      contractAddress: matchedCoin && matchedCoin.contractAddress != null ? matchedCoin.contractAddress : this.getCoinContractAddress(queryCoin),
      ...(matchedCoin || {})
    };
    this.network = this.coin.network || queryNetwork || "TRX";
    this.getAddress();
    this.getAllTransactionHistory();
  },
  watch: {
    size() {
      if (!this.size) {
        this.size = 10;
      }
      this.getAllTransactionHistory();
    },
    page() {
      // setPagination.apply(this, [`${this.page}`]);
      this.getAllTransactionHistory();
    },
    coins(newCoins) {
      if (newCoins && newCoins.length) {
        if (!this.coin) {
          const defaultCoin = newCoins.find(c => c.id === "USDT_TRX") || newCoins[0];
          this.coin = {
            ...defaultCoin,
            minDeposit: defaultCoin.minDeposit != null ? defaultCoin.minDeposit : this.getCoinMinDeposit(defaultCoin.id),
            minConfirmation: defaultCoin.minConfirmation != null ? defaultCoin.minConfirmation : this.getCoinMinConfirmation(defaultCoin.id),
            contractAddress: defaultCoin.contractAddress != null ? defaultCoin.contractAddress : this.getCoinContractAddress(defaultCoin.id),
            network: defaultCoin.network || "TRX"
          };
          this.network = this.coin.network;
        } else {
          const matched = newCoins.find(c => c.id === this.coin.id || c.coin === this.coin.id);
          if (matched) {
            this.coin = {
              ...this.coin,
              ...matched,
              minDeposit: matched.minDeposit != null ? matched.minDeposit : (this.coin.minDeposit || this.getCoinMinDeposit(this.coin.id)),
              minConfirmation: matched.minConfirmation != null ? matched.minConfirmation : (this.coin.minConfirmation || this.getCoinMinConfirmation(this.coin.id)),
              contractAddress: matched.contractAddress != null ? matched.contractAddress : (this.coin.contractAddress || this.getCoinContractAddress(this.coin.id)),
              network: matched.network || this.coin.network || "TRX"
            };
            if (!this.network) {
              this.network = this.coin.network;
            }
          }
        }
      }
    },
    coin(newVal, oldVal) {
      if (!newVal) return;
      if (newVal.minDeposit == null) {
        newVal.minDeposit = this.getCoinMinDeposit(newVal.id);
      }
      if (newVal.minConfirmation == null) {
        newVal.minConfirmation = this.getCoinMinConfirmation(newVal.id);
      }
      if (newVal.contractAddress == null) {
        newVal.contractAddress = this.getCoinContractAddress(newVal.id);
      }
      if (!newVal.network) {
        newVal.network = "TRX";
      }
      this.network = newVal.network;
      if (!oldVal || (newVal.network && newVal.network != oldVal.network)) {
        this.getAddress();
      }
    }
  },
  methods: {
    getCoinMinDeposit(coinId) {
      const map = {
        USDT_TRX: "0.1",
        TRX: "0.1",
        USDT: "1",
        BTC: "0.0001",
        ETH: "0.005",
        BNB: "0.01"
      };
      return (coinId && map[coinId]) ? map[coinId] : "0.1";
    },
    getCoinMinConfirmation(coinId) {
      const map = {
        USDT_TRX: 15,
        TRX: 15,
        USDT: 15,
        BTC: 2,
        ETH: 12,
        BNB: 15
      };
      return (coinId && map[coinId]) ? map[coinId] : 15;
    },
    getCoinContractAddress(coinId) {
      const map = {
        USDT_TRX: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
        USDT: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t"
      };
      return (coinId && map[coinId]) ? map[coinId] : "";
    },
    async copy(text) {
      await utils_clipboard.apply(this, [`${text}`]);
    },
    customSort(a, b, key, order) {
      if (key != this.field && order != this.order) {
        this.order = order;
        this.field = key;
      }
    },
    async getAllTransactionHistory() {
      try {
        const res = await new libs_api_api().api({
          method: "GET",
          url: `asset/tx/search`
        }, {
          page: this.page,
          size: this.size,
          txType: "DEPOSIT"
        }, {
          isLoading: true
        });
        if (res && res.cryptoTxList) {
          this.items = res.cryptoTxList.map(item => {
            return {
              ...item,
              createdTime: utils_constants.dateFormat(item.createdTime),
              txIdStr: utils_constants.showOnlyLastFiveChar(item.txId),
              toAddressStr: utils_constants.showOnlyLastFiveChar(item.toAddress)
            };
          });
          // this.items = res.cryptoTxList;
          this.totalRows = res.count;
          if (res.count && res.count > this.size) {
            this.isPaginationVisible = true;
          } else {
            this.isPaginationVisible = false;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async getAddress() {
      try {
        if (this.coin && this.coin.network) {
          const res = await new libs_api_api().api({
            method: "GET",
            url: `asset/address`
          }, {
            network: this.coin.network
          }, {
            isLoading: true
          });
          if (res && res.address) {
            this.address = res.address;
            // this.QRcodeImage = res.QRcodeImage;
          } else if (res && res.error && res.error.message) {
            if (res.error.code == 592) {
              return;
            }
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        } else {
          this.address = "";
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async createAddress() {
      try {
        const res = await new libs_api_api().api({
          method: "POST",
          url: `asset/address`
        }, {
          network: this.coin.network
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.address = res.address;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/wallet/Deposit.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.info-card-r {
  font-size: 12px;
}
.p2p-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.p2p-filter .filter-area {
  display: flex;
  align-items: center;
}
[dir] .p2p-filter .filter-area .vs--single .vs__dropdown-toggle {
  padding: 2px;
}
[dir=ltr] .p2p-filter .filter-area .vs__actions {
  padding: 0px 6px 0 3px;
}
[dir=rtl] .p2p-filter .filter-area .vs__actions {
  padding: 0px 3px 0 6px;
}
.p2p-filter .filter-area .col-20-p {
  min-width: 210px;
}
[dir=ltr] .p2p-filter .filter-area .col-20-p {
  padding-right: 15px;
}
[dir=rtl] .p2p-filter .filter-area .col-20-p {
  padding-left: 15px;
}
.p2p-filter .filter-area .col-20-p .min-drop.v-select {
  min-width: 200px;
}
[dir=ltr] .p2p-filter .refresh-btn {
  text-align: right;
}
[dir=rtl] .p2p-filter .refresh-btn {
  text-align: left;
}
.content1 {
  color: #8dc540;
  font-size: 34px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 2.38px;
}
.h4 {
  color: var(--text-black-color);
  font-size: 21px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 1.47px;
}
[dir] .h4 {
  margin: 16px 0px 16px 0px;
}
.amt {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 1.33px;
}
.Search {
  color: #6e6b7b;
  font-size: 16px;
  font-weight: 400;
}
.text-lable {
  color: #7f7f7f;
  font-size: 13.234px;
  font-weight: 500;
  line-height: 10px;
}
[dir] .placeholder-below-text {
  margin-top: 5px;
}
.amt-usdt {
  color: #8e8c8c;
  font-size: 17px;
  font-weight: 600;
  line-height: 36px;
}
.you-get {
  font-size: 25px;
  font-weight: 600;
  line-height: 36px;
}
.Withdraw-btn {
  min-width: 160px;
}
.Send {
  color: var(--text-black-color);
  font-weight: bold;
}
[dir] .Send {
  margin: 15px 0px 15px 0px;
}
[dir=ltr] .you-amount {
  border-right: none !important;
}
[dir=rtl] .you-amount {
  border-left: none !important;
}
.you-max {
  color: var(--primary);
}
[dir=ltr] .you-max {
  border-left: none !important;
  border-right: 3px solid #d8d6de !important;
}
[dir=rtl] .you-max {
  border-right: none !important;
  border-left: 3px solid #d8d6de !important;
}
[dir=ltr] .dark-layout .you-max {
  border-right: 3px solid #404656 !important;
}
[dir=rtl] .dark-layout .you-max {
  border-left: 3px solid #404656 !important;
}
.fqa {
  width: 100%;
  height: 100%;
}
[dir] .fqa {
  border: 1px solid #d8d6de;
}
.orcode {
  max-width: 100px;
  max-height: 100px;
}
[dir=ltr] .orcode {
  padding-right: 10px;
}
[dir=rtl] .orcode {
  padding-left: 10px;
}
.orimg {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}
[dir] .orimg {
  border: 0;
}
[dir] .rounded {
  padding-top: 10px;
  padding-bottom: 10px;
}
.add-h {
  min-height: 25px;
}
.w-rt {
  text-wrap: wrap;
  max-width: 100%;
}
</style>
